import React from 'react';
import styled from 'styled-components';
import { selectColor } from '@panel/commons/core/theme';
import facebookIcon from '../../../assets/icons/facebook.svg';
import instagramIcon from '../../../assets/icons/instagram.svg';
import corazonIcon from '../../../assets/icons/corazon.png';
import interesadosIcon from '../../../assets/icons/interesados.svg';
import visitasIcon from '../../../assets/icons/visitas.svg';
import pinIcon from '../../../assets/icons/pin.png';

const SocialAdsModal = ({ isMobile, socialAdsReport }) => {
  const { urlFacebook, urlInstagram, startDays, endDays, viewsCount, leads, leadsCount, upgrade } = socialAdsReport;
  const handleClick = path => {
    window.location.href = window.location.origin.concat(path);
  };
  const formatedUpgrade = upgrade && upgrade.split(',');
  return (
    <ContentLayout isMobile={isMobile}>
      <div className='social-header'>¡Tu campaña está activa!</div>
      <div className='button-container'>
        <button type='button' onClick={() => handleClick(urlFacebook)} className='social-button facebook'>
          <img src={facebookIcon} alt='logo facebook' />
          <p>Verla en Facebook</p>
        </button>
        <button type='button' onClick={() => handleClick(urlInstagram)} className='social-button instagram'>
          <img src={instagramIcon} alt='logo instagram' />
          <p>Verla en Instagram</p>
        </button>
      </div>
      <div className='social-startDays'>
        En {startDays || 0} {startDays !== 1 ? 'días' : 'día'}:
      </div>
      <div className='items-container'>
        <div className='item-detail'>
          <div className='img-container'>
            <img src={visitasIcon} alt='Icono visitas' />
          </div>
          <div className='social-count'>{viewsCount}</div>
          <p>Vieron tu aviso en Facebook e Instagram</p>
        </div>
        <div className='item-detail'>
          <div className='img-container'>
            <img src={corazonIcon} alt='Icono corazon' />
          </div>
          <div className='social-count'>{leadsCount}</div>
          <p>Interactuaron con el (Me gusta, Comentarios, Compartir)</p>
        </div>
        <div className='item-detail'>
          <div className='img-container'>
            <img src={interesadosIcon} alt='Icono interesados' />
          </div>
          <div className='social-count'>{leads}</div>
          <p>Enviaron una consulta</p>
        </div>
      </div>
      <div className='social-advice'>
        <div className='social-advice-img'>
          <img src={pinIcon} alt='icono pin' />
        </div>
        <p>
          {upgrade
            ? `La información se actualiza diariamente, los últimos datos fueron recibidos el ${
                formatedUpgrade[0]
              } a las ${formatedUpgrade[1]}hs`
            : 'Empezarás a ver tus resultados después de 24 horas de haber activado la campaña'}
        </p>
      </div>
      <p className='social-endDays'>Todavía quedan {endDays || 0} días de campaña</p>
    </ContentLayout>
  );
};

const facebookColor = '#3b5998';
const instagramColor = '#DD2A7B';

const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  .social-header {
    color: ${selectColor('gray50')};
    font-size: 24px;
  }
  .button-container {
    width: 500px;
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
    .social-button {
      color: white;
      width: 48%;
      display: flex;
      height: 42px;
      font-size: 18px;
      justify-content: center;
      border-radius: 6px;
      align-items: center;
      cursor: pointer;
      img {
        height: 20px;
        margin-bottom: 4px;
        margin-right: 6px;
      }
    }
    .facebook {
      background-color: ${facebookColor};
    }
    .instagram {
      background-color: ${instagramColor};
    }
  }
  .social-startDays {
    font-size: 18px;
    color: ${selectColor('grayDark')};
  }
  .items-container {
    display: flex;
    width: 500px;
    justify-content: space-between;
    margin: 20px 0;
    .item-detail {
      max-width: 146px;
      white-space: normal;
      display: flex;
      flex-direction: column;
      align-items: center;
      .img-container {
        background-color: ${selectColor('blue5')};
        width: 60px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        img {
          height: 40px;
          width: 40px;
        }
      }
      .social-count {
        font-weight: 500;
        font-size: 24px;
      }
      p {
        text-align: center;
        color: ${selectColor('grayDark')};
      }
    }
  }
  .social-advice {
    border: 1px solid ${selectColor('blue50')};
    border-radius: 6px;
    width: 500px;
    overflow: hidden;
    display: flex;
    height: fit-content;
    .social-advice-img {
      background-color: ${selectColor('blue5')};
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    p {
      white-space: normal;
      color: ${selectColor('grayDark')};
      padding: 12px;
      width: 450px;
      line-height: 16px;
    }
  }
  .social-endDays {
    font-size: 18px;
    color: ${selectColor('grayDark')};
    margin-top: 20px;
  }
`;

export default SocialAdsModal;
